import { Components, Theme } from '@mui/material/styles';

export const MuiTypography: Components<Theme>['MuiTypography'] = {
  styleOverrides: {
    root: {
    },
    noWrap: {
      display: 'block',
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
};
